import { render } from "./MailPost.vue?vue&type=template&id=3dbb078a"
import script from "./MailPost.vue?vue&type=script&lang=js"
export * from "./MailPost.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Projects\\fostcrm-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__